export default __webpack_public_path__ + "static/media/figma.f216a119.svg";